<template>
  <md-list-item @click="showSetup = true">
    <md-icon>settings</md-icon>
    <span class="md-list-item-text">Setup</span>
    <md-dialog :md-active.sync="showSetup" :md-click-outside-to-close="false">
      <md-dialog-title>Setup</md-dialog-title>
      <form class="md-layout" v-on:submit.prevent="saveSetup">
        <md-card class="setup">
          <md-tabs md-alignment="fixed">
            <md-tab id="tab-user" md-label="User" md-icon="person">
              <md-field>
                <label>First Name</label>
                <md-input v-model="this.userfirstname"></md-input>
              </md-field>
              <md-field>
                <label>Last Name</label>
                <md-input v-model="this.userlastname"></md-input>
              </md-field>
              <md-field>
                <label>Email</label>
                <md-input v-model="this.useremail"></md-input>
              </md-field>
              <md-field>
                <label>Color</label>
                <md-input v-model="this.usercolor"></md-input>
              </md-field>
              <md-field>
                <label>Account Level</label>
                <md-input v-model="this.userlevel"></md-input>
              </md-field>
            </md-tab>
            <md-tab id="tab-team" md-label="Team" md-icon="group">
              <md-field>
                <label>Team Name</label>
                <md-input v-model="this.teamname"></md-input>
                <span class="md-helper-text">Name your Team</span>
              </md-field>
              <md-field>
                <label>Twilio Account SID</label>
                <md-input v-model="this.teamTwilioAccountSID"></md-input>
                <span class="md-helper-text">From the top of your Twilio Account Dashboard Page</span>
              </md-field>
              <md-field>
                <label>Twilio Auth Token</label>
                <md-input v-model="this.teamTwilioAuthToken"></md-input>
                <span class="md-helper-text">From Right below the Account SID (click the <md-icon>visibility_off</md-icon>)</span>
              </md-field>
              <md-field>
                <label>Twilio SMS Number</label>
                <md-input v-model="this.teamTwilioSMSNumber"></md-input>
                <span class="md-helper-text">What Twilio number will you use for Team Texting? (Use E.164 format, please.)</span>
              </md-field>
            </md-tab>
          </md-tabs>
        </md-card>
        <md-progress-bar md-mode="indeterminate" v-if="sending" />
        <md-dialog-actions>
          <md-button class="xmd-primary" @click="showSetup = false">Close</md-button>
          <md-button class="md-primary" @click="saveSetup">Save</md-button>
        </md-dialog-actions>
      </form>
    </md-dialog>
  </md-list-item>
</template>

<script>
// import firebase from 'firebase'
import db from '../services/firebase'
import { mapFields } from 'vuex-map-fields'

export default {
  // name: 'setup',
  data () {
    return {
      showSetup: false,
      sending: false
    }
  },
  computed: {
    ...mapFields([
      'userfirstname',
      'userlastname',
      'useremail',
      'usercolor',
      'userlevel',
      'userTwilioAccountSID',
      'teamTwilioAccountSID',
      'teamTwilioAuthToken',
      'teamTwilioSMSNumber',
      'teamname',
      'teamlastupdate'
    ])
  },
  watch: {
    showSetup: function (newshowSetup, oldshowSetup) {
      console.log('oldshowSetup: ' + oldshowSetup)
      console.log('newshowSetup: ' + newshowSetup)
    }
  },
  methods: {
    saveSetup: function () {
      this.sending = true
      console.log(this.userdata)
      db.collection('users').doc(this.userdata.email).update({
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        color: this.user.color,
        level: this.user.level,
        TwilioAccountSID: this.user.TwilioAccountSID
      })
      console.log('User data saved')
      db.collection('teams').doc(this.user.TwilioAccountSID).update({
        TwilioAccountSID: this.team.TwilioAccountSID,
        TwilioAuthToken: this.team.TwilioAuthToken,
        TwilioSMSNumber: this.team.TwilioSMSNumber,
        teamname: this.team.teamname
      })
      console.log('Team data saved')
      this.sending = false
      this.showSetup = false
    }
  }
}
</script>

<style lang="css" scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.md-card {
  width: 100%;
  padding: 10px;
}
.setup {
  min-width: 250px;
  min-height: 500px;
}
.left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Setup.vue